'use strict';

const Alerts = require('lib/alerts');

const MainView = require('../views/Main');
const PayrollSubmissionsView = require('../views/payrollSubmissions/Main');
const CompaniesView = require('../views/companies/Main');
const ReportsView = require('../views/Reports');
const PayrollsView = require('../views/payrolls/Main');
const ChangeLogsView = require('../views/changeLogs/Main');
const EmployeesView = require('../views/employees/Main');
const MPPAccountsView = require('../views/mppAccounts/Main');
const PersonalSettingsView = require('commons/views/PersonalSettings');
const CouponsView = require('../views/coupons/Main.js');
const BaseRouter = require('commons/routers/Base');
const loader = require('helpers/loader');
const SettingsRouter = require('./Settings');
import UsersView from '../views/users/Main.js';

import Company from 'newModels/company.js';
import Coupon from 'newModels/coupon.js';

import Attachments from 'newCollections/attachments.js';
import Companies from 'newCollections/companies.js';
import Payrolls from 'newCollections/payrolls.js';
import ChangeLogs from 'newCollections/change-logs.js';
import Employees from 'newCollections/employees.js';
import Users from 'newCollections/users.js';
import Coupons from 'newCollections/coupons.js';
import Positions from 'newCollections/positions.js';
import CompanyLocations from 'newCollections/company-locations.js';
import LeaveTypes from 'newCollections/leave-types.js';

module.exports = BaseRouter.extend({
    routes: {
        'payrollSubmissions': 'payrollSubmissions',
        'reports': 'reports',
        'personalSettings': 'personalSettings',
        'users': 'users',
        'users/:sort/:order': 'users',
        'users/:sort/:order/:search': 'users',
        'companies': 'companies',
        'companies/:sort/:order': 'companies',
        'companies/:sort/:order/:searchTerm': 'companies',
        'companies/:sort/:order/:searchTerm/:mppSearchTerm': 'companies',
        'payrolls/:companyId': 'payrolls',
        'logs/:companyId': 'changeLogs',
        'employees/:companyId': 'employees',
        'employees/:companyId/:searchTerm': 'employees',
        'mppAccounts': 'mppAccounts',
        'coupons': 'coupons'
    },

    titles: {
        'payrollSubmissions': 'Payroll Submissions',
        'reports': 'Reports',
        'personalSettings': 'Personal Settings',
        'users': 'Users',
        'companies': 'Companies',
        'companies/:sort/:order': 'Companies',
        'companies/:sort/:order/:searchTerm': 'Companies',
        'companies/:sort/:order/:searchTerm/:mppSearchTerm': 'Companies',
        'payrolls/:companyId': 'Payrolls',
        'logs/:companyId': 'Logs',
        'employees/:companyId': 'Employees',
        'employees/:companyId/:searchTerm': 'Employees',
        'mppAccounts': 'MPP Accounts'
    },

    childEl: '#main-area',

    // The initialization of this router is way to complex because the
    // MainView is the container for all the others and it requires async
    // info. TODO Fix MainView
    initialize: function() {
        this.mainView = new MainView({});

        this.subRouters = [
            new SettingsRouter({el: this.childEl})
        ];

        Backbone.history.on('route', function() {
            this.mainView.setActiveLink(Backbone.history.getFragment());
            window.scrollTo(0, 0);
        }.bind(this));
    },

    companies: function(sortKey, sortOrder, searchStr, mppSearchStr) {
        const options = {
            sortKey:    'companyName',
            sortOrder:  'ascending',
            pagination: {limit: 25}
        };

        if (sortKey) { options.sortKey = sortKey; }
        if (sortOrder) { options.sortOrder = sortOrder; }
        if (searchStr && searchStr !== '__all') {
            options.searchString = searchStr;
        }
        if (mppSearchStr && mppSearchStr !== '__all') {
            options.mppSearchString = mppSearchStr;
        }

        this.undelegateEvents();
        return Promise.all([
            new Users(undefined, {pagination: false}).fetch({filter: {
                where: {role: 'mpp_admin'},
                limit: 9999
            }}),
            Coupon.getDiscountCodes()
        ])
        .then(([mppAdmins, discountCodes]) => {
            this.view = new CompaniesView({
                el: this.mainView.childEl,
                collection: new Companies(null, options),
                mppAdmins,
                discountCodes
            });
        });
    },

    payrollSubmissions: function() {
        var stopLoader = loader.startFullPage(this.mainView.childEl);

        const payrolls = new Payrolls(null, {pagination: false});

        payrolls.fetch({
            filter: {
                where: {
                    and: [
                        {
                            status: {
                                gte: 3
                            }
                        },
                        {
                            status: {
                                lt: 9
                            }
                        }
                    ]
                },
                limit: 9999
            }
        })
        .then(() => {
            const payrollAttachments = payrolls.map(p => {
                let atmts = new Attachments(null, {attachable: p});

                return atmts.fetch()
                    .then(() => {
                        return [
                            p.id,
                            atmts
                        ];
                    });
            });

            const payrollCompanies = payrolls.map(p => {
                return p.fetchCompany();
            });

            return Promise.all(payrollAttachments, payrollCompanies);
        })
        .then((payrollAttachments) => {
            app.payrolls = payrolls;

            this.undelegateEvents();
            this.view = new PayrollSubmissionsView({
                el:          this.mainView.childEl,
                collection:  payrolls,
                attachments: _.object(payrollAttachments)
            });
        })
        .catch(err => { Alerts.show('criticalError', err);})
        .finally(stopLoader);
    },

    reports: function() {
        this.undelegateEvents();
        this.view = new ReportsView({
            el: this.mainView.childEl
        });
    },

    personalSettings: function() {
        this.undelegateEvents();
        this.view = new PersonalSettingsView({
            el:    this.mainView.childEl,
            model: app.user
        });
    },

    users: function(sortKey, sortOrder, searchStr) {
        const options = {
            sortKey:    'username',
            sortOrder:  'ascending',
            pagination: {limit: 25}
        };

        if (sortKey) { options.sortKey = sortKey; }
        if (sortOrder) { options.sortOrder = sortOrder; }
        if (searchStr && searchStr !== '__all') {
            options.searchString = searchStr;
        }

        this.undelegateEvents();
        this.view = new UsersView({
            el: this.mainView.childEl,
            collection: new Users(null, options)
        });
    },

    payrolls: function(companyId) {
        this.undelegateEvents();
        const stopLoader = loader.startFullPage(this.mainView.childEl);
        const company = new Company({objectId: companyId});
        const attachments = {};

        function getAttachments(payroll) {
            return new Attachments(null, {
                attachable: payroll,
                pagination: false
            })
            .fetch({filter: {limit: 9999}})
            .then(collection => attachments[payroll.id] = collection);
        }

        company.fetch()
            .then(() => Promise.all([
                company.fetchPayrolls(),
                company.fetchSubscription()
            ]))
            .then(([payrolls]) => Promise.all(payrolls.map(payroll => {
                return getAttachments(payroll);
            })).then(() => payrolls))
            .then(payrolls => {
                this.view = new PayrollsView({
                    el:    this.mainView.childEl,
                    collection: payrolls,
                    company: company,
                    attachments: attachments
                }).render();
            })
            .finally(() => stopLoader());
    },

    changeLogs: function(companyId) {
        this.undelegateEvents();
        const stopLoader = loader.startFullPage(this.mainView.childEl);
        const company = new Company({objectId: companyId});
        const positions = new Positions(null, {
            company,
            pagination: false
        });
        const locations = new CompanyLocations(null, {
            company,
            pagination: false
        });
        const leaveTypes = new LeaveTypes(null, {
            company,
            pagination: false
        });
        return company.fetch()
            .then(() => {
                return Promise.all([
                    positions.fetch({filter: {
                        where: {hiddenAt: null},
                        limit: 9999
                    }}),
                    locations.fetch({filter: {
                        where: {hiddenAt: null},
                        limit: 9999
                    }}),
                    leaveTypes.fetch({filter: {
                        limit: 9999
                    }})
                ]);
            }).then(() => {
                this.view = new ChangeLogsView({
                    el: this.mainView.childEl,
                    collection: new ChangeLogs(null, {
                        company,
                        pagination: {limit: 25},
                        filter: {}
                    }),
                    company,
                    positions,
                    locations,
                    leaveTypes
                }).render();
            })
            .finally(stopLoader);
    },

    mppAccounts: function() {
        this.undelegateEvents();
        let stopLoader = loader.startFullPage(this.mainView.childEl);
        return Promise.all([
            new Users(null, {pagination: false})
                .fetch({filter: {where: {role: 'mpp_admin'}}}),
            Coupon.getDiscountCodes()
        ])
            .then(([collection, discountCodes]) => {
                this.view = new MPPAccountsView({
                    el: this.mainView.childEl,
                    collection,
                    discountCodes
                }).render();
            })
            .finally(() => stopLoader());
    },

    employees: function(companyId, searchStr) {
        this.undelegateEvents();
        let options = {
            sortKey: 'fullName',
            sortOrder: 'ascending',
            pagination: {limit: 25},
            filter: {}
        };
        if (searchStr) {
            options.searchString = searchStr;
        }

        if (!companyId || companyId === 'all') {
            this.view = new EmployeesView({
                el: this.mainView.childEl,
                collection: new Employees(null, options)
            });
            return;
        }

        options.filter.where = {
            companyId: companyId,
            hiddenAt: null
        };

        const stopLoader = loader.startFullPage(this.mainView.childEl);
        new Company({objectId: companyId})
            .fetch()
            .then(company => {
                this.view = new EmployeesView({
                    el: this.mainView.childEl,
                    collection: new Employees(null, options),
                    company: company
                }).render();
            })
            .finally(stopLoader);
    },

    coupons: function() {
        this.undelegateEvents();
        let stopLoader = loader.startFullPage(this.mainView.childEl);
        new Coupons(null, {pagination: false}).fetch({
            filter: {
                limit: 9999
            }
        })
            .then(coupons => {
                this.view = new CouponsView({
                    el: this.mainView.childEl,
                    collection: coupons
                }).render();
            })
            .finally(stopLoader);
    }

});



// WEBPACK FOOTER //
// ./app/adminManager/routers/Main.js